export class BankLoanRequest {
  public AvailLoan: boolean = false;
  public LoanAmount: number;
  public PANNo: string;
  public DateOfBirth: Date;
  public BankName: string;
  public OtherBank: string;
}
